module.exports = __webpack_public_path__ + "img/icon-1-2.d6ea9338.png";